/**
 * Carztohire brand logo — uses the official /logo.png (trimmed).
 * Size is controlled by parent's font-size via the className prop —
 * pass a Tailwind text-* class and the image scales to match.
 * `tone`: "navy" (default, dark-navy artwork) or "white" (color-inverted for dark backgrounds).
 */
export default function Logo({ className = "", tone = "navy" }) {
  const src = tone === "white" ? "/logo-white.png" : "/logo.png";
  return (
    <span
      className={`inline-flex items-center leading-none ${className}`}
      data-testid="brand-logo"
      aria-label="Carztohire"
    >
      <img
        src={src}
        alt="CARZTOHIRE"
        style={{ height: "2.4em", width: "auto", display: "block" }}
      />
    </span>
  );
}
